import * as React from 'react';
import { CurrentClientIdType } from '../current-client-route-state-context';

export type CurrentClientRouteDispatchContextType =
    | ((newClientId: CurrentClientIdType) => void)
    | undefined;

export const CurrentClientRouteDispatchContext = React.createContext<CurrentClientRouteDispatchContextType>(undefined);
CurrentClientRouteDispatchContext.displayName = 'CurrentClientRouteDispatchContext';
